import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { CognitoService } from './services/cognito.service';
import { SessionService } from './services/session.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class ApiHttpInterceptor implements HttpInterceptor {

  constructor (private _sessionService: SessionService, private cognito: CognitoService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const newReq = this._sessionService.getApiRequestHeaders().then(headers => {
      if (headers) {
        req = req.clone({
          setHeaders: headers
        });
      }
      return req;
    }).catch(err => {
      return req;
    })

    return from(newReq).pipe(mergeMap(
      (asyncToken: HttpRequest<any> | null) => {
        return next.handle(req);
      }
    ));
  }
}